import { Typography, TypographyProps } from "@mui/material";

interface IProps extends TypographyProps {
  title: string;
}
const Heading: React.FC<IProps> = ({ title, ...props }) => {
  return (
    <Typography
      variant="h2"
      color="text.primary"
      mb={{ xs: 2, md: 3 }}
      {...props}
    >
      {title}
    </Typography>
  );
};

export default Heading;
